var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMusicIconinline = function SvgMusicIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "ca"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B275F0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0758A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.406 4.525a.622.622 0 00-.504-.142L11.238 6.52a.625.625 0 00-.528.617v12.245a3.467 3.467 0 00-.709-.445c-.923-.43-2.03-.466-3.037-.097-1.974.723-3.05 2.775-2.399 4.574.295.816.91 1.476 1.729 1.858.5.233 1.054.35 1.617.35.476 0 .959-.084 1.42-.253 1.39-.508 2.332-1.677 2.542-2.951a.618.618 0 00.087-.313V11.682L24.374 9.74v7.473c-.204-.16-.427-.3-.67-.413-.923-.43-2.03-.466-3.037-.097-1.974.723-3.05 2.775-2.4 4.573.296.817.91 1.477 1.73 1.859.5.233 1.053.35 1.616.35.477 0 .96-.084 1.421-.253 1.438-.526 2.395-1.758 2.56-3.083a.614.614 0 00.03-.181V5a.625.625 0 00-.218-.475z",
    id: "cb"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#ca)",
    cx: 32.5,
    cy: 32.5,
    r: 32.5
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#cb",
    transform: "translate(17 18)"
  }))));
};
export default SvgMusicIconinline;